import { usePathname } from 'next/navigation';

import { BreadcrumbList } from '@/components/@base/breadcrumb/type';
import Options from '@/components/shared/helpers/hooks/breadcrumb-generator/type';

import localization from '@/constant/localization';

export function useBreadcrumbGenerator(options?: Options): BreadcrumbList[] {
  let paths =
    options?.customPath && options.customPath.length > 0 ? options.customPath : usePathname();

  // Remove '/page/[number]' from the end of the path if it exists
  paths = paths.replace(/\/page\/\d+$/, '');

  let currentRoute = '';
  return [
    { label: localization.home, url: '/', active: false },

    ...paths
      .split('/')
      .filter((path) => path && !options?.excludeRoutes?.includes(path))
      ?.map((path, index, newPaths) => {
        currentRoute = `${currentRoute}/${path}/`;
        return {
          label: options?.customLabels ? options.customLabels[path] : localization[path],
          url: index < newPaths.length - 1 ? currentRoute : undefined,
          active: newPaths.length - 1 === index,
        };
      }),
  ];
}
